module.exports = __webpack_public_path__ + "img/equipos-moviles-img-3.9a9ccbb1.jpg";